import {
    REQUEST_CUSTOMER_SEARCH,
    CUSTOMER_SEARCH_SUCCESS,
    CUSTOMER_SEARCH_FAILURE,
    REQUEST_CUSTOMER_CREATE_RETURN,
    CUSTOMER_CREATE_RETURN_SUCCESS,
    CUSTOMER_CREATE_RETURN_FAILURE,
    REQUEST_CUSTOMER_EDIT_RETURN,
    CUSTOMER_EDIT_RETURN_SUCCESS,
    CUSTOMER_EDIT_RETURN_FAILURE,
    REQUEST_DISPATCH_EDIT_RETURN,
    DISPATCH_EDIT_RETURN_SUCCESS,
    DISPATCH_EDIT_RETURN_FAILURE,
    REQUEST_DISPATCH_SEARCH,
    DISPATCH_SEARCH_SUCCESS,
    DISPATCH_SEARCH_FAILURE,
    SET_RETURNS_FILTER,
    RESET_CURRENT_FORM,
    RETURN_SEARCH_SUCCESS,
    RESET_CURRENT_RETURN,
    //fix goes here
} from '../actions/type';


const INITIAL_STATE = {
    customerReturns: [],
    dispatchReturns: [],
    isLoading: false,
    error: null,
    customerReturnError: null,
    dispatchReturnError: null,
    isCreating: false,
    createCustomerReturnError: null,
    created: false,
    editCustomerReturnError: null,
    editDispatchReturnError: null,
    isEditing: false,
    returnsFilter: null,
    initialValue: {},
    currentReturnDetail: undefined,
}

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {
        case REQUEST_CUSTOMER_SEARCH:
            return {...state, customerReturnError: null, isLoading: true}
        case CUSTOMER_SEARCH_SUCCESS:
            return {...state, customerReturns: action.payload.data, customerReturnError: null, isLoading: false};
        case CUSTOMER_SEARCH_FAILURE:
            const customerReturnError = action.payload || {message: action.payload.message}
            return {...state, customerReturns: [], customerReturnError: customerReturnError, isLoading: false};
        case REQUEST_CUSTOMER_CREATE_RETURN:
            return {...state, isCreating: true, createCustomerReturnError: null, created: false};
        case CUSTOMER_CREATE_RETURN_SUCCESS:
            return {...state, isCreating: false, createCustomerReturnError: null, created: true};
        case CUSTOMER_CREATE_RETURN_FAILURE:
            const createCustomerReturnError = action.payload.data || {message: action.payload.message}
            return {...state, isCreating: false, createCustomerReturnError: createCustomerReturnError, created: false};
        case REQUEST_CUSTOMER_EDIT_RETURN:
            return {...state, isEditing: true, editCustomerReturnError: null, edited: false};
        case CUSTOMER_EDIT_RETURN_SUCCESS:
            return {...state, isEditing: false, editCustomerReturnError: null, edited: true};
        case CUSTOMER_EDIT_RETURN_FAILURE:
            const editCustomerReturnError = action.payload || {message: action.payload.message}
            return {...state, isEditing: false, editCustomerReturnError: editCustomerReturnError, edited: false};
        case REQUEST_DISPATCH_EDIT_RETURN:
            return {...state, isEditing: true, editDispatchReturnError: null, edited: false};
        case DISPATCH_EDIT_RETURN_SUCCESS:
            return {...state, isEditing: false, editDispatchReturnError: null, edited: true};
        case DISPATCH_EDIT_RETURN_FAILURE: 
            const editDispatchReturnError = action.payload || {message: action.payload.message}
            return {...state, isEditing: false, editDispatchReturnError: editDispatchReturnError, edited: false}
        case REQUEST_DISPATCH_SEARCH:
            return {...state, dispatchReturnError: null, isLoading: true};
        case DISPATCH_SEARCH_SUCCESS:
            return {...state, dispatchReturns: action.payload.data, dispatchReturnError: null, isLoading: false};
        case DISPATCH_SEARCH_FAILURE:
            const dispatchReturnError = action.payload || {message: action.payload.message}
            return {...state, dispatchReturns: [], dispatchReturnError: dispatchReturnError, isLoading: false};
        case SET_RETURNS_FILTER:
            return { ...state, returnsFilter: action.payload };
        case RESET_CURRENT_FORM:
            return {
                ...state, currentReturn: null, currentReturnDetail: null, editCustomerReturnError: null, createCustomerReturnError: null, created: null, edited: null,
            };
        case RETURN_SEARCH_SUCCESS:
            return { ...state, currentReturnDetail: action.payload };
        case RESET_CURRENT_RETURN:
            return { ...state, currentReturnDetail: null };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./master/jsx/reducers/rma_reducers.js